var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotConnected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 98,
    viewBox: "0 0 111 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_8040_11146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0092 34.8339C31.7193 27.1074 37.748 20.6088 45.4745 20.3189L63.0806 19.6585C70.8072 19.3686 77.3057 25.3973 77.5956 33.1238L78.256 50.7299C78.5459 58.4565 72.5173 64.955 64.7907 65.2449L47.1846 65.9053C39.4581 66.1952 32.9595 60.1665 32.6696 52.44L32.0092 34.8339Z",
    fill: "url(#paint0_linear_8040_11146)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_8040_11146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0092 34.8339C31.7193 27.1074 37.748 20.6088 45.4745 20.3189L63.0806 19.6585C70.8072 19.3686 77.3057 25.3973 77.5956 33.1238L78.256 50.7299C78.5459 58.4565 72.5173 64.955 64.7907 65.2449L47.1846 65.9053C39.4581 66.1952 32.9595 60.1665 32.6696 52.44L32.0092 34.8339Z",
    fill: "url(#paint1_linear_8040_11146)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8040_11146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.0991 31.9543L59.1077 38.1833",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8828 32.1875L65.3241 37.9501",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6645 46.8632L65.7769 49.8611C65.7886 50.1394 65.7398 50.4171 65.6338 50.6764C65.5277 50.9357 65.3668 51.171 65.1612 51.3671C64.9556 51.5632 64.71 51.7159 64.44 51.8153C64.17 51.9147 63.8816 51.9587 63.5933 51.9444C60.3927 51.7299 57.2908 50.794 54.5371 49.212C51.9762 47.7716 49.7771 45.8042 48.0958 43.4494C46.2471 40.9081 45.0461 37.9809 44.5901 34.9048C44.5539 34.6294 44.5775 34.3497 44.6594 34.0833C44.7414 33.8169 44.8799 33.5697 45.0662 33.3575C45.2524 33.1453 45.4823 32.9727 45.7413 32.8507C46.0002 32.7288 46.2825 32.6601 46.5702 32.649L49.6783 32.5324C50.181 32.5088 50.6748 32.6622 51.0679 32.9641C51.461 33.2661 51.7265 33.6959 51.8149 34.1735C51.9821 35.1279 52.2607 36.0608 52.6455 36.9543C52.7983 37.3067 52.8431 37.6943 52.7744 38.0711C52.7058 38.4479 52.5267 38.7981 52.2584 39.0803L50.9902 40.3988C52.5589 42.8452 54.7843 44.8361 57.4314 46.1613L58.6996 44.8429C58.9712 44.5636 59.3199 44.3651 59.7044 44.2709C60.0888 44.1767 60.4929 44.1907 60.8688 44.3112C61.8215 44.6142 62.8069 44.8123 63.8064 44.9015C64.3122 44.9511 64.781 45.1784 65.1236 45.5401C65.4662 45.9018 65.6587 46.3727 65.6645 46.8632Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_8040_11146)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_8040_11146",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.616 23.7866C65.4872 20.3535 68.166 17.4659 71.5991 17.3371C75.0323 17.2083 77.9199 19.8871 78.0487 23.3203C78.1775 26.7534 75.4987 29.641 72.0655 29.7698C68.6323 29.8986 65.7448 27.2198 65.616 23.7866Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.616 23.7866C65.4872 20.3535 68.166 17.4659 71.5991 17.3371C75.0323 17.2083 77.9199 19.8871 78.0487 23.3203C78.1775 26.7534 75.4987 29.641 72.0655 29.7698C68.6323 29.8986 65.7448 27.2198 65.616 23.7866Z",
    fill: "url(#paint2_linear_8040_11146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.616 23.7866M78.0487 23.3203M78.0487 23.3203M65.616 23.7866M71.5991 17.3371M78.0487 23.3203M72.0655 29.7698M65.616 23.7866M72.0655 29.7698L71.9906 27.7712C69.6612 27.8586 67.702 26.0411 67.6146 23.7117L65.616 23.7866L63.6174 23.8616C63.7876 28.3986 67.6035 31.9386 72.1405 31.7684L72.0655 29.7698ZM78.0487 23.3203L76.0501 23.3952C76.1375 25.7246 74.3199 27.6838 71.9906 27.7712L72.0655 29.7698L72.1405 31.7684C76.6775 31.5982 80.2175 27.7823 80.0473 23.2453L78.0487 23.3203ZM71.5991 17.3371L71.6741 19.3357C74.0035 19.2483 75.9627 21.0658 76.0501 23.3952L78.0487 23.3203L80.0473 23.2453C79.8771 18.7083 76.0611 15.1683 71.5242 15.3385L71.5991 17.3371ZM71.5991 17.3371L71.5242 15.3385C66.9872 15.5087 63.4472 19.3246 63.6174 23.8616L65.616 23.7866L67.6146 23.7117C67.5272 21.3823 69.3447 19.4231 71.6741 19.3357L71.5991 17.3371Z",
    fill: "white",
    mask: "url(#path-6-inside-1_8040_11146)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8040_11146",
    x: -0.515625,
    y: -12.8672,
    width: 111.297,
    height: 111.297,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_8040_11146"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_8040_11146",
    x: 19.4844,
    y: 17.1328,
    width: 71.2969,
    height: 71.2969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8040_11146"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8040_11146"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8040_11146"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8040_11146",
    result: "effect2_dropShadow_8040_11146"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8040_11146",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_8040_11146",
    x: 53.3828,
    y: 15.1016,
    width: 36.8984,
    height: 36.8984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8040_11146"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8040_11146"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8040_11146"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8040_11146",
    result: "effect2_dropShadow_8040_11146"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8040_11146",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8040_11146",
    x1: 31.4844,
    y1: 20.8438,
    x2: 78.7809,
    y2: 64.7201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A7282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#364153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8040_11146",
    x1: 31.4844,
    y1: 20.8438,
    x2: 78.7809,
    y2: 64.7201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A7282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#364153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8040_11146",
    x1: 65.3828,
    y1: 17.5703,
    x2: 78.2819,
    y2: 29.5366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A7282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#364153"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8040_11146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.8828,
    height: 24,
    fill: "white",
    transform: "translate(42.2344 30.8125) rotate(-2.14832)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotConnected);
export default __webpack_public_path__ + "static/media/Not Connected.93856a85b1d587cb8f4ec992ae0114d8.svg";
export { ForwardRef as ReactComponent };